export default __webpack_public_path__ + "static/media/paperiarpa.16dd5ec3.png";